import * as ngCore from '@angular/core'

import * as overlay from '../../overlay'

import { ICONS } from './icons'

/** TODO */
@ngCore.Component({
  imports: [overlay.attached.Component],
  selector: 'atn-ds-iconpicker',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Available {@link ICONS icons} for selection
   */
  public readonly icons = ICONS

  /**
   * Label displayed above the icon picker
   *
   * @default undefined
   */
  public readonly labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /** Currently selected icon value */
  public readonly valueSg = ngCore.model<string | undefined>(undefined, {
    alias: 'value',
  })

  /** Tracks whether the icon picker dropdown/panel is currently open  */
  public readonly isOpenSg = ngCore.signal(false)

  /** Handles icon selection */
  public selectIconHandler(icon: string) {
    this.valueSg.set(icon)
    this.isOpenSg.set(false)
  }
}
